import isEditStore from "./isEditStore";
import loadingStore from "./loadingStore";

export default {
  isEditStore,
  loadingStore,
};
